import React from 'react';
import { Box, Button, Text, WixDesignSystemProvider } from '@wix/design-system';
import { openModal } from '@wix/business-manager-api';
import { DisplayError } from './common/DisplayError';
export const PmaActionSuggestionWidget = _ref => {
  var _data$payload, _data$displayMessage, _data$displayMessage2;
  let {
    data,
    context
  } = _ref;
  const review = () => {
    openModal('1d835d4e-75b3-4c87-978d-061b9ec4eb70', {
      title: 'Review',
      execution: {
        payload: data.payload
      },
      onApprove: () => context.send('Approved')
    });
  };
  return /*#__PURE__*/React.createElement(WixDesignSystemProvider, {
    features: {
      newColorsBranding: true
    }
  }, data.success && /*#__PURE__*/React.createElement(Box, {
    gap: "8px",
    border: "1px solid red",
    borderRadius: "12px",
    borderColor: "B40",
    padding: "SP2",
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, (_data$payload = data.payload) == null ? void 0 : _data$payload.description), /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    align: "right",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "tiny",
    target: "_blank",
    onClick: review
  }, "Review"))), !data.success && /*#__PURE__*/React.createElement(DisplayError, {
    message: (_data$displayMessage = data.displayMessage) == null ? void 0 : _data$displayMessage.message,
    cta: (_data$displayMessage2 = data.displayMessage) == null ? void 0 : _data$displayMessage2.cta
  }));
};
export const PMA_ACTION_SUGGESTION_WIDGET = 'PMA_ACTION_SUGGESTION_WIDGET';
//# sourceMappingURL=PmaActionSuggestionWidget.js.map